import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Users, Brain, BarChart, Settings, LogOut, 
  Briefcase, Shield, Database, Book
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

import AIWorkforceDevelopment from '../components/enterprise/AIWorkforceDevelopment';
import HRIntegration from '../components/enterprise/HRIntegration';
import AISkillAssessment from '../components/AISkillAssessment';
import AIVideoLessons from '../components/AIVideoLessons';
import AILearningPath from '../components/AILearningPath';

const EnterpriseDashboardPage = () => {
  const [activeTab, setActiveTab] = useState('workforce');
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-background border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <Brain className="h-8 w-8 text-accent" />
                <span className="ml-2 text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-indigo-600">
                  Panel Empresarial
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button className="text-foreground/70 hover:text-foreground">
                <Settings className="h-5 w-5" />
              </button>
              <div className="border-l border-border h-6"></div>
              <div className="flex items-center">
                <div className="h-8 w-8 rounded-full bg-accent/10 flex items-center justify-center text-accent font-medium">
                  {user?.user_metadata?.name?.[0] || 'A'}
                </div>
                <span className="ml-2 text-sm font-medium text-foreground">
                  {user?.user_metadata?.name || 'Admin'}
                </span>
                <button 
                  onClick={handleSignOut}
                  className="ml-4 text-foreground/70 hover:text-foreground"
                >
                  <LogOut className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col lg:flex-row lg:space-x-8">
          {/* Sidebar */}
          <div className="lg:w-64 flex-shrink-0 mb-8 lg:mb-0">
            <nav className="space-y-1">
              <button
                onClick={() => setActiveTab('workforce')}
                className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg ${
                  activeTab === 'workforce'
                    ? 'bg-accent text-white'
                    : 'text-foreground/70 hover:bg-accent/10 hover:text-accent'
                }`}
              >
                <Users className="h-5 w-5 mr-3" />
                Desarrollo de Personal
              </button>
              <button
                onClick={() => setActiveTab('integrations')}
                className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg ${
                  activeTab === 'integrations'
                    ? 'bg-accent text-white'
                    : 'text-foreground/70 hover:bg-accent/10 hover:text-accent'
                }`}
              >
                <Database className="h-5 w-5 mr-3" />
                Integraciones
              </button>
              <button
                onClick={() => setActiveTab('assessment')}
                className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg ${
                  activeTab === 'assessment'
                    ? 'bg-accent text-white'
                    : 'text-foreground/70 hover:bg-accent/10 hover:text-accent'
                }`}
              >
                <Shield className="h-5 w-5 mr-3" />
                Evaluación de Habilidades
              </button>
              <button
                onClick={() => setActiveTab('learning')}
                className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg ${
                  activeTab === 'learning'
                    ? 'bg-accent text-white'
                    : 'text-foreground/70 hover:bg-accent/10 hover:text-accent'
                }`}
              >
                <Book className="h-5 w-5 mr-3" />
                Contenido Formativo
              </button>
              <button
                onClick={() => setActiveTab('paths')}
                className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg ${
                  activeTab === 'paths'
                    ? 'bg-accent text-white'
                    : 'text-foreground/70 hover:bg-accent/10 hover:text-accent'
                }`}
              >
                <Briefcase className="h-5 w-5 mr-3" />
                Rutas de Aprendizaje
              </button>
            </nav>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            {activeTab === 'workforce' && <AIWorkforceDevelopment />}
            {activeTab === 'integrations' && <HRIntegration />}
            {activeTab === 'assessment' && <AISkillAssessment />}
            {activeTab === 'learning' && <AIVideoLessons />}
            {activeTab === 'paths' && <AILearningPath userId={user?.id || ''} careerPath="enterprise" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseDashboardPage;